import styled from 'styled-components'

import { CustomDotWrapperProps } from './types'

const CustomDotWrapper = styled.li<CustomDotWrapperProps>`
  cursor: pointer;
`
export default CustomDotWrapper
